export const WEB_FORM_ACTION_BUTTON_TEST_ID = 'web-form-action-button-test-id';
